<template>
    <v-alert elevation="0" color="disabledarrowback" class="pa-0 ma-2" style="width:130px;">
        <div class="d-flex flex-row">
            <div class="d-flex justify-center flex-column mr-1" style="width:80px;color:white;">
                <div class="headline pa-1 primary">
                    <div class="overline">
                        {{ filial }}
                    </div>
                    <div class="display-1">{{ quantidadeHoje }}</div>
                </div>
            </div>
            
                <div class="d-flex flex-row auto justify-center">

                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" v-if="quantidadeHoje > quantidadeOntem" color="primary" large>mdi-arrow-up-bold</v-icon>
                            <v-icon v-on="on" v-else-if="quantidadeHoje === quantidadeOntem" color="disabledarrow" x-large>mdi-arrow-up-bold</v-icon>
                            <v-icon v-on="on" v-else color="red accent-4" large>mdi-arrow-down-bold</v-icon>
                        </template>
                        <span>Ontem: {{ quantidadeOntem }}</span>
                    </v-tooltip>

                </div>
            
        </div>
    </v-alert>
</template>
<script>
export default {

    name: 'ResumoVendaDia',
    props: {
        filial: {
            type: String,
            required: true
        },
    },

    data(){
        return {
            quantidadeHoje: 0,
            quantidadeOntem: 0,
        }
    },

    created(){

    },


    mounted(){
        this.obterTotalDeHoje()
        this.obterTotalDeOntem()
    },

    methods: {

        hoje(){
            return new Date(Date.now()).toISOString().substring(0,10)
        },

        ontem(){
            let hoje = Date.now()
            let ontem = hoje + -1*24*3600*1000;
            return new Date(ontem).toISOString().substring(0,10)
        },

        obterTotalDeHoje() {
            this.$store.dispatch('obterVendas', {cc_fil: this.filial, dt_fat_i: this.hoje(), dt_fat_f: this.hoje()}).then(resp => {
                resp.data.forEach(el => {
                    this.quantidadeHoje += parseInt(el.qt_fat)
                })
            }).catch(err => {
                console.log(err)
            })
        },

        obterTotalDeOntem(){
            this.$store.dispatch('obterVendas', {cc_fil: this.filial, dt_fat_i:this.ontem(), dt_fat_f:this.ontem()}).then(resp => {
                resp.data.forEach(el => {
                    this.quantidadeOntem += parseInt(el.qt_fat)
                })
            }).catch(err => {
                console.log(err)
            })
        }

    }

}
</script>